import React from "react";

import { useField } from "formik";

import { DateInput as DateInputBase } from "components/Form/DateInput";
import { Column } from "components/Layout";

import { Error } from "./Error";
import { Label } from "./Label";

export const DateInput = ({
  disabled,
  label,
  min,
  name,
  onChangeExtra,
  required,
  tooltip,
  includeTime,
  showErrorUntouched,
  dataTour,
}) => {
  const [field, meta, helpers] = useField(name);
  const { setValue, setTouched } = helpers;

  const error = (showErrorUntouched || meta.touched) && meta.error;

  const dateString =
    field.value instanceof Date &&
    // Handles case when the field value is a date, but is an invalid one
    // eslint-disable-next-line no-self-compare
    field.value.getTime() === field.value.getTime()
      ? field.value.toISOString().substr(0, 10)
      : field.value || "";

  function onChangeDateInput(event) {
    let { value } = event.target;
    if (value === "") {
      value = null;
    }
    setValue(value).then(() => {
      setTouched(true);
    });
    typeof onChangeExtra === "function" && onChangeExtra(value);
  }

  return (
    <Column fullWidth>
      <Label
        htmlFor={name}
        required={required}
        error={!!error}
        tooltip={tooltip}
      >
        {label}
      </Label>
      <DateInputBase
        data-tour={dataTour || field.name}
        value={dateString}
        labelledBy={name}
        onBlur={field.onBlur}
        onChange={onChangeDateInput}
        disabled={disabled}
        required={required}
        min={min}
        name={name}
        includeTime={includeTime}
      />
      {error && <Error>{error}</Error>}
    </Column>
  );
};
